import script from "./ProjectExportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectExportDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProjectExportDialog.vue?vue&type=style&index=0&id=850d9a1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-850d9a1e"]])

export default __exports__